import { TEXTS } from '../../constants';
import {
  SectionWrapper,
  ContentWrapper,
  SectionHeading,
  SectionSubtext,
  BioCard,
  BioText,
} from './styles';

const BiographySection = ({ fullBio, bio, firstName, fullName }) => {
  const content = fullBio || bio;
  if (!content) return null;

  const displayFirstName =
    firstName || (fullName && fullName.split(' ')[0]) || '';

  // Bio comes from a single-line GHL field with no real line breaks.
  // Paragraphs are separated by "||" (also support real blank lines).
  const paragraphs = String(content)
    .split(/\s*\|\|\s*|\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <SectionWrapper>
      <ContentWrapper>
        <SectionHeading>
          {TEXTS.biography.getTitle(displayFirstName)}
        </SectionHeading>
        <SectionSubtext>{TEXTS.biography.subtitle}</SectionSubtext>
        <BioCard>
          {paragraphs.map((paragraph, index) => (
            <BioText
              key={index}
              sx={{ mb: index < paragraphs.length - 1 ? 2 : 0 }}
            >
              {paragraph}
            </BioText>
          ))}
        </BioCard>
      </ContentWrapper>
    </SectionWrapper>
  );
};

export default BiographySection;
